var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as fromStore from '../_store';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import * as _ from 'lodash';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TAP_MILES_AND_GO_FF_TIER_LEVELS, TAP_MILES_AND_GO_GOLD, TAP_MILES_AND_GO_MILES, TAP_MILES_AND_GO_MILS, TAP_MILES_AND_GO_NAVIGATOR, TAP_MILES_AND_GO_SILVER } from '@ibe.config';
import { PassengerDetailEmergencyContactComponent } from './passenger-detail-emergency-contact/passenger-detail-emergency-contact.component';
import { PassengerDetailPersonalDocumentsComponent } from './passenger-detail-personal-documents/passenger-detail-personal-documents.component';
import { FrequentFlyerComponent } from './frequent-flyer/frequent-flyer.component';
import { PassengerDetailContactsComponent } from './passenger-detail-contacts/passenger-detail-contacts.component';
import { Actions } from '@ngrx/effects';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { FormGroupService } from '@ibe.services/form-group.service';
var PassengersDetailsIndraComponent = /** @class */ (function () {
    function PassengersDetailsIndraComponent(store, fb, route, actions$, sidebarService, fbService, bfmStorage // TODO[Lucas Santos]: Remove after all be in storage
    ) {
        this.store = store;
        this.fb = fb;
        this.route = route;
        this.actions$ = actions$;
        this.sidebarService = sidebarService;
        this.fbService = fbService;
        this.bfmStorage = bfmStorage;
        this.anyFormHasChanges$ = this.store.select(fromStore.getSelectedAnyFormHasChanges).pipe(filter(function (data) { return !_.isEmpty(data); }), map(function (obj) { return _.reduce(obj, function (i, val, k) { return val && !(i[k] = val) || i; }, {}); }));
        this.showSave = false;
        this.passengerInfo$ = this.store.select(fromStore.getSelectedPassengersAtIndex);
        this.subs$ = new Subscription();
        this._saving = false;
    }
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "saving", {
        get: function () {
            return this._saving;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "passengerInfo", {
        get: function () {
            return this._passengerInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "notInfant", {
        get: function () {
            return !Object.is('INF', this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "_hasFrequentFlyer", {
        get: function () {
            return ((this.passengerInfo.tierLevelFF)
                && TAP_MILES_AND_GO_FF_TIER_LEVELS.includes(this.passengerInfo.tierLevelFF));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "loyaltyLogo", {
        get: function () {
            if (_.isNil(this._loyaltyLogo)) {
                switch (this.passengerInfo.tierLevelFF) {
                    case TAP_MILES_AND_GO_MILES:
                    case TAP_MILES_AND_GO_MILS:
                        this._loyaltyLogo = 'loyalty--miles_go';
                        break;
                    case TAP_MILES_AND_GO_SILVER:
                        this._loyaltyLogo = 'loyalty--miles_go_silver';
                        break;
                    case TAP_MILES_AND_GO_GOLD:
                        this._loyaltyLogo = 'loyalty--miles_go_gold';
                        break;
                    case TAP_MILES_AND_GO_NAVIGATOR:
                        this._loyaltyLogo = 'loyalty--navigator';
                        break;
                    default:
                        this._loyaltyLogo = '';
                }
            }
            return this._loyaltyLogo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengersDetailsIndraComponent.prototype, "logoClasses", {
        get: function () {
            if (_.isNil(this._logoClasses)) {
                switch (this.passengerInfo.tierLevelFF) {
                    case TAP_MILES_AND_GO_MILES:
                    case TAP_MILES_AND_GO_MILS:
                        this._logoClasses = 'logo__miles-go';
                        break;
                    case TAP_MILES_AND_GO_SILVER:
                        this._logoClasses = 'logo__miles-go-silver';
                        break;
                    case TAP_MILES_AND_GO_GOLD:
                        this._logoClasses = 'logo__miles-go-gold';
                        break;
                    case TAP_MILES_AND_GO_NAVIGATOR:
                        this._logoClasses = 'logo__navigator';
                        break;
                    default:
                        this._logoClasses = '';
                }
            }
            return this._logoClasses;
        },
        enumerable: true,
        configurable: true
    });
    PassengersDetailsIndraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.pnr = this.route.snapshot.paramMap.get('pnr');
        this.subs$.add(this.passengerInfo$.subscribe(function (data) {
            _this._passengerInfo = data;
        }));
        this.subs$.add(this.store.select(fromStore.getSelectedNotif).subscribe(function (data) {
            _this._saving = false;
            _this.notif = data;
        }));
        this.subs$.add(this.actions$.pipe(filter(function (action) { return Object.is(fromStore.ActionTypes.SAVE_PASSENGER_SUCCESS, action.type); })).subscribe(function () {
            _this._saving = false;
            // TODO [LUCAS_SANTOS]: UPDATE STATE OF BOOKING DETAILS TO USE STORE AND NOT STORAGE
            _this.store.select(fromStore.getSelectedBookedTripInfoPax).pipe(take(1)).subscribe(function (data) {
                _this.bfmStorage.INDRA_setActiveBookInfoPax(data);
                _this.sidebarService.closeSidebar();
            });
        }));
    };
    PassengersDetailsIndraComponent.prototype.ngOnDestroy = function () {
        this.subs$.unsubscribe();
        // TODO [Lucas Santos]: Sidebar Component not Emit OnClose when click outside or press ESC Key
        this.onClose();
    };
    PassengersDetailsIndraComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.subs$.add(this.anyFormHasChanges$.pipe(filter(function (data) { return !_.isEmpty(data); })).subscribe(function () { return setTimeout(function () { return _this.showSave = Boolean(true); }); }));
        this.subs$.add(this.anyFormHasChanges$.pipe(filter(function (data) { return _.isEmpty(data); })).subscribe(function () { return setTimeout(function () { return _this.showSave = Boolean(false); }); }));
    };
    PassengersDetailsIndraComponent.prototype.saveSidebar = function () {
        var _this = this;
        this.anyFormHasChanges$
            .pipe(take(1))
            .subscribe(function (data) {
            if (_this.validateForms(data)) {
                _this._saving = true;
                _this.store.dispatch(new fromStore.SavePassenger(__assign({}, data, { emergencyContact: _this.componentAndFormExists(_this.emergencyContactComp) ? _this.emergencyContactComp.form.value : {}, travelDocument: _this.componentAndFormExists(_this.personalDocsComp) ? _this.personalDocsComp.form.value : {}, frequentFlyer: _this.componentAndFormExists(_this.frequentFlyerComp) ? _this.frequentFlyerComp.form.value : {}, contact: _this.componentAndFormExists(_this.passengerContactsComp) ? _this.passengerContactsComp.form.value : {} }), _this.pnr, _this.passengerInfo.idPax));
            }
        });
    };
    PassengersDetailsIndraComponent.prototype.componentAndFormExists = function (component) {
        return !_.isNil(component) && !_.isNil(component.form);
    };
    PassengersDetailsIndraComponent.prototype.onClose = function () {
        this.store.dispatch(new fromStore.CancelEditing());
    };
    PassengersDetailsIndraComponent.prototype.hideNotifications = function () {
        this.store.dispatch(new fromStore.HideNotificationAction());
    };
    PassengersDetailsIndraComponent.prototype.validateForms = function (tags) {
        var _this = this;
        var isValid = false;
        Object.keys(tags).forEach(function (key) {
            switch (key) {
                case 'updateDocument':
                case 'updateDoca':
                case 'updateRedress': {
                    _this.fbService.markFormAsTouched(_this.personalDocsComp.form);
                    isValid = _this.personalDocsComp.form.valid;
                    break;
                }
                case 'updateEmergencyContact': {
                    _this.fbService.markFormAsTouched(_this.emergencyContactComp.form);
                    isValid = _this.emergencyContactComp.form.valid;
                    break;
                }
                case 'updateContact': {
                    _this.fbService.markFormAsTouched(_this.passengerContactsComp.form);
                    isValid = _this.passengerContactsComp.form.valid;
                    break;
                }
                case 'updateFrequentFlyer': {
                    _this.fbService.markFormAsTouched(_this.frequentFlyerComp.form);
                    isValid = _this.frequentFlyerComp.form.valid;
                    break;
                }
                default:
                    isValid = false;
            }
        });
        return isValid;
    };
    return PassengersDetailsIndraComponent;
}());
export { PassengersDetailsIndraComponent };
